var BitcoinNetwork;
(function (BitcoinNetwork) {
    BitcoinNetwork["Mainnet"] = "mainnet";
    BitcoinNetwork["Testnet"] = "testnet";
})(BitcoinNetwork || (BitcoinNetwork = {}));
export default BitcoinNetwork;
//# sourceMappingURL=network.js.map